export const json: any = {
    url: 'http://sanesinternacionales.com:3152',
    socket: 'http://sanesinternacionales.com:3152',
    dev_url: 'http://localhost:3000',
    dev_socket: 'http://localhost:3000',
    title: 'Sanes Internacionales',
    tableColor: '#414042',
    compania: 1,
    prodEnv: true
};



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/assets/data/routemee.ts